export default __webpack_public_path__ + "static/media/i (14).1cbd9adb.jpg";